import { Button, Icon, Spin, Table } from 'antd';
import { ColumnProps } from 'antd/es/table';
import React, { useMemo, useState } from 'react';
import { useTypedSelector } from '../../../../core-module/redux';
import { Payment } from '../../../../core-module/services/payments/types';
import { PaymentsDetailsModal } from './PaymentDetails/PaymentsDetailsModal';
import { formatDateString, formatPrice } from './helpers';
import { useDriverPaymentsQuery } from './useDriverDeployabilityOptionsQuery';

const PaymentsOverviewContainer: React.FC = () => {
  const driverId = useTypedSelector((state) => state.auth.user.driver!.id);
  const [activePaymentIdForDetails, setActivePaymentIdForDetails] = useState<number | undefined>();

  const driverPaymentsState = useDriverPaymentsQuery(driverId);

  const payments = useMemo(() => {
    if (driverPaymentsState.type === 'USABLE' || driverPaymentsState.type === 'FETCHING') {
      if (!driverPaymentsState.data) {
        return [];
      }

      return driverPaymentsState.data.payments;
    }

    return [];
  }, [driverPaymentsState]);

  const columns: ColumnProps<Payment>[] = useMemo(() => {
    if (!payments) {
      return [];
    }

    const columns: ColumnProps<Payment>[] = [
      {
        title: 'Periode',
        key: 'Period',
        width: '15%',
        render: (text, record, index) =>
          `${formatDateString(record.periodStartDate)} - ${formatDateString(
            record.periodEndDate
          )}` || ''
      },
      {
        title: 'Bedrag',
        key: 'total_amount',
        width: '15%',
        render: (text, record, index) => formatPrice(record.totalAmount) || ''
      },
      {
        title: 'Acties',
        key: 'day_note',
        render: (_, record) => {
          return (
            <>
              <Button
                style={{ marginRight: 5, top: '-1px' }}
                onClick={() => setActivePaymentIdForDetails(record.id)}
                type='primary'
                htmlType='button'
              >
                <Icon type='eye' />
              </Button>
              <PaymentsDetailsModal
                payment={record}
                onClose={() => setActivePaymentIdForDetails(undefined)}
                show={activePaymentIdForDetails === record.id}
              />
            </>
          );
        }
      }
    ];

    return columns;
  }, [activePaymentIdForDetails, payments]);

  const loading = driverPaymentsState.type === 'LOADING';
  return (
    <Spin spinning={loading} delay={500}>
      <Table
        rowKey={(row, index) => index.toString()}
        dataSource={payments}
        locale={{ emptyText: 'Geen opties gevonden' }}
        bordered={true}
        pagination={false}
        columns={columns}
        loading={loading}
      />
    </Spin>
  );
};

export { PaymentsOverviewContainer };
